module.exports = __webpack_public_path__ + "media/images/official/special_workcation_08-404374261a2fc6401bbad51a31d9cb0e.jpg";